export default __webpack_public_path__ + "static/media/amazonBankGreenLogo.14477790.svg";